import styled from "styled-components";

interface IResultPrice {
  smallFont: boolean
}

interface IPriceProps {
  largeWidth: boolean
}

export const Container = styled.div`
  margin: 36px auto 0;
  display: flex;
  flex-direction: column;
  
  @media (min-width: 980px) {
    flex-direction: row;
    margin: 40px auto 0;
    align-items: center;
    width: 860px;
  }
`

export const Button = styled.button`
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: #4E4963;
  content: 'Для физических лиц';
  cursor: pointer;
  width: 229px;
  padding: 8px 16px 8px 16px;
  border-radius: 8px;
  &:active {
    font-weight: 700;
    background: #EFEEF5;
  }
  &:last-child {
    margin-left: 20px;
  }
`

export const TextBtn = styled.div`
  &:before {
    content: 'Для юридических лиц';
  }
  @media (max-width: 530px) {
    &:before {
      content: 'Для юр. лиц';
    }
  }
`

export const TextBtnPerson = styled.div`
  &:before {
    content: 'Для физических лиц';
  }
  @media (max-width: 530px) {
    &:before {
      content: 'Для физ. лиц';
    }
  }
`

export const ButtonBold = styled.button`
  font-size: 16px;
  font-weight: 700;
  background: #EFEEF5;
  line-height: 26px;
  color: #4E4963;
  cursor: pointer;
  width: 229px;
  padding: 8px 16px 8px 16px;
  border-radius: 8px;
  &:active {
    font-weight: 700;
    background: #EFEEF5;
  }
  &:last-child {
    margin-left: 20px;
  }
`

export const BlockBtn = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
`

export const Accordion = styled.div`
  margin: 60px auto 0;
  
  @media (min-width: 980px) {
    width: 860px;
  }
`

export const Footnote = styled.div`
  margin: 36px auto 0;
  font-weight: 400;
  font-size: 18px;
  color: #2A2637;
  font-style: italic;
`

export const Left = styled.div`
  order: 2;
  @media (min-width: 980px) {
    flex: ${(props: IPriceProps) => props.largeWidth ? '0 0 45%' : '0 0 40%'};
    order: 1;
    margin-bottom: 0;
  }
`

export const Right = styled.div`
  order: 1;
  margin-bottom: 40px;
  
  @media (min-width: 980px) {
    margin-bottom: 0;
    flex: ${(props: IPriceProps) => props.largeWidth ? '0 0 55%' : '0 0 60%'};
    order: 2;
  }
`


export const BlockTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 160%;
  color: #2A2637;
  margin-bottom: 16px;

  @media (min-width: 980px) {
    font-size: 18px;
  }
`

export const InputBlock = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
  color: #797199;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;

  @media (min-width: 980px) {
    font-size: 18px;
  }
`

export const PriceText = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
  color: #797199;

  @media (min-width: 980px) {
    font-size: 18px;
  }
`

export const MultSign = styled.span`
  margin-right: 3px;
`

export const IconWrapp = styled.div`
  padding: 0 0 40px 0;
  position: relative;

  @media (min-width: 980px) {
    position: relative;
    padding: 0;
  }
`

export const IconBg = styled.div`
  background: #AAB1FF;
  opacity: 0.5;
  border-radius: 10px;
  height: 93px;
  margin: 0 auto;
  width: 215px;
  
  @media (min-width: 980px) {
    height: 313px;
    margin-left: auto;
    margin-right: inherit;
  }
`

export const IconPlace = styled.div`
  position: absolute;
  background: rgba(25, 22, 34, 0.9);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-width: 315px;
  width: 100%;
  left: 0;
  top: 27px;
  padding: 15px;

  @media (min-width: 980px) {
    right: 40px;
    top: 50%;
    transform: translateY(-50%);
    padding: 30px 50px;
    width: auto;
    left: inherit;
  }
`

export const IconPlaceUZ = styled.div`
  position: absolute;
  background: rgba(25, 22, 34, 0.9);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-width: 315px;
  width: 100%;
  left: 0;
  top: 27px;
  padding: 15px;

  @media (min-width: 980px) {
    right: 40px;
    top: 50%;
    transform: translateY(-50%);
    padding: 44px 50px;
    width: auto;
    left: inherit;
  }
`

export const ResultPrice = styled.div<IResultPrice>`
  font-weight: 700;
  line-height: 140%;
  color: #FFFFFF;
  font-size: 36px;
`

export const ResultPriceBold = styled.div<IResultPrice>`
  font-weight: 700;
  font-size: 56px;
  line-height: 140%;
  color: #FFFFFF;

  @media (min-width: 980px) {
    font-size: ${({ smallFont }) => smallFont ? '36px' : '56px'};
  }
`

export const PeriodText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #877EAA;

  @media (min-width: 980px) {
    font-size: 24px;
  }
`

export const Content = styled.div`
  margin-top: 60px;
`

export const Wrapper = styled.div`
  position: relative;
`

export const Calculate = styled.div`
  background: rgba(170, 177, 255, 0.5);
  border-radius: 10px;
  width: 100%;
  max-width: 480px;
  height: 200px;
  margin: 0 auto;
  padding: 21px 0;
`

export const CalculateBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #EFEEF5;
  border-radius: 8px;
  width: 215px;
  padding: 0 12px;
  transition: .2s ease-in-out;
  border: 1px solid #EFEEF5;
  
  &:hover {
    border: 1px solid #0D71D7;
  }
`

export const IncDecBtn = styled.button`
  margin: 0 8px
`

export const UsersCountInput = styled.input`
  text-align: center;
  font-size: 14px;
  color: #2A2637;
  border-radius: 4px;
  width: 100%;
  max-width: 220px;
  transition: border 0.2s;
  line-height: 160%;
  padding: 10px;
  
  &::-webkit-input-placeholder {
    font-size: 18px;
    color: #A8A4B9;
  }
  
  &::-moz-placeholder {
    font-size: 18px;
    color: #A8A4B9;
  }
  
  &:-moz-placeholder {
    font-size: 18px;
    color: #A8A4B9;
  }
  
  &:-ms-input-placeholder {
    font-size: 18px;
    color: #A8A4B9;
  }

  @media (min-width: 980px) {
    font-size: 18px;
  }
`

export const AdditionalModules = styled.div``
export const AdditionalModulesList = styled.div``
export const AdditionalModule = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`
export const ModuleCheck = styled.div`
  display: flex;
  align-items: center;
  
  .onlinepbx__lib__checkbox__label {
    margin-left: 24px;
    font-weight: 500;
    font-size: 14px;
    line-height: 160%;
    color: #2A2637;

    @media (min-width: 980px) {
      font-size: 18px;
    }
  }

  .onlinepbx__lib__question {
    z-index: initial;
  }
`

export const ModuleTitle = styled.div`
  margin-left: 24px;
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
  color: #2A2637;

  @media (min-width: 980px) {
    font-size: 18px;
  }
`

export const ModuleCost = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
  color: #797199;

  @media (min-width: 980px) {
    font-size: 18px;
  }
`

export const Result = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  margin: 25px 0 0;
  left: 0;
  right: 0;
`

export const ResultText = styled.div`
  background: rgba(25, 22, 34, 0.9);
  border-radius: 10px;
  color: #FFFFFF;
  font-size: 48px;
  font-weight: 600;
  padding: 42px 60px;
  max-width: 410px;

  @media (min-width: 375px) {
    padding: 42px 65px;
  }
  
  @media (min-width: 980px) {
    font-size: 72px;
  }
`

export const ResultTextPersonal = styled(ResultText)`
  font-weight: 500;
  font-size: 18px;
  padding: 45px 36px;
  line-height: 1.5em;
  text-align: center;
`

export const ResultLink = styled.a`
  color: #aab1ff
`

export const Default = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  margin: 55px 0 0;

  @media (min-width: 980px) {
    margin: 120px 0 0;
    align-items: flex-start;
  }
`

export const DefaultBlock = styled.div`
  flex: 0 0 100%;
  padding: 15px 0;

  @media (min-width: 414px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
  
  @media (min-width: 980px) {
    margin: 24px 41px;
    padding: 0;
    flex: 0 0 auto;
  }
`

export const DefaultHeader = styled.div`
  color: #797199;
  font-size: 14px;
  margin: 0 0 12px;
`

export const DefaultSubtitle = styled(DefaultHeader)`
  margin-top: 5px;
`

export const DefaultResult = styled.div`
  color: #4E4963;
  font-size: 18px;
  font-weight: 600;
`

export const AccordionQuestionListContainer = styled.div`
  

  @media (min-width: 980px) {
    display: flex;
  }
`

export const AccordionQuestionList = styled.ul`
  margin: 0 0 0 30px;
  padding: 0;
  flex: 0 0 50%;

  @media (min-width: 980px) {
    margin: 12px 0 0 30px;
  }
`

export const AccordionQuestionListItem = styled.li``
